
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function PresentacionPage() {
  useEffect(() => {
    // Schema.org JSON-LD for Organization and Course
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${import.meta.env.VITE_SITE_URL}/#organization`,
          "name": "INDEFINHUM",
          "url": import.meta.env.VITE_SITE_URL,
          "logo": {
            "@type": "ImageObject",
            "url": `${import.meta.env.VITE_SITE_URL}/vite.svg`
          },
          "description": "Empresa líder en educación de Inteligencia Artificial para instituciones educativas",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+52-55-2369-8187",
            "contactType": "customer service",
            "email": "indefinhum@gmail.com"
          }
        },
        {
          "@type": "Course",
          "@id": `${import.meta.env.VITE_SITE_URL}/#course`,
          "name": "Curso de Inteligencia Artificial para Educación",
          "description": "Curso completo de 24 módulos de IA diseñado específicamente para instituciones educativas, desde nivel principiante hasta experto",
          "provider": {
            "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
          },
          "courseCode": "IA-EDU-24",
          "numberOfCredits": 24,
          "educationalLevel": "K-12, Higher Education",
          "teaches": [
            "Fundamentos de Inteligencia Artificial",
            "Machine Learning",
            "Redes Neuronales",
            "Visión por Computadora",
            "Procesamiento de Lenguaje Natural",
            "IA Ética y Responsable"
          ],
          "offers": {
            "@type": "Offer",
            "price": "90000",
            "priceCurrency": "MXN",
            "availability": "https://schema.org/InStock"
          }
        },
        {
          "@type": "WebSite",
          "@id": `${import.meta.env.VITE_SITE_URL}/#website`,
          "url": import.meta.env.VITE_SITE_URL,
          "name": "INDEFINHUM - Curso de IA para Educación",
          "description": "Plataforma educativa especializada en cursos de Inteligencia Artificial para instituciones educativas",
          "publisher": {
            "@id": `${import.meta.env.VITE_SITE_URL}/#organization`
          }
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600">
      <Header />
      
      {/* Título Principal Centrado */}
      <section className="bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 py-12 sm:py-16 text-center">
        <div className="container mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            El Futuro de la 
            <span className="bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent"> Educación </span>
            está en la IA
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-blue-100 mb-6 sm:mb-8 leading-relaxed max-w-3xl mx-auto px-4">
            Curso Integral de Inteligencia Artificial para Instituciones Educativas
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 sm:mb-12 px-4">
            <Link 
              to="/modulos"
              className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-6 py-3 rounded-full font-semibold text-base hover:shadow-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-book-line mr-2"></i>
              Ver Módulos del Curso
            </Link>
            <Link 
              to="/precios"
              className="border-2 border-yellow-400 text-yellow-300 px-6 py-3 rounded-full font-semibold text-base hover:bg-yellow-400 hover:text-blue-900 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              <i className="ri-price-tag-3-line mr-2"></i>
              Ver Precios
            </Link>
          </div>
        </div>
      </section>

      {/* Hero Section - Solo imagen sin texto superpuesto */}
      <section 
        className="relative h-64 sm:h-80 md:h-96 lg:min-h-screen bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(6, 182, 212, 0.3), rgba(59, 130, 246, 0.3)), url('https://public.readdy.ai/ai/img_res/82c086ccb4dbff2213a9faaaf87bae5e.jpg')`
        }}
      >
      </section>

      {/* Sección de contenido que estaba superpuesta - ahora independiente */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600">
        <div className="container mx-auto px-4 sm:px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Transforma la Manera de Enseñar y Aprender
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-blue-100 mb-6 sm:mb-8 leading-relaxed px-4">
              Prepara a tus estudiantes para el mundo digital con nuestro programa completo de 24 módulos
            </p>
          </div>
        </div>
      </section>

      {/* Importancia de la IA en Educación */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-cyan-500">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
              La IA: Una Revolución Educativa Inevitable
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-blue-100 max-w-3xl mx-auto px-4">
              La inteligencia artificial no es solo el futuro, es el presente que está transformando la manera en que los niños aprenden y se preparan para el mundo digital.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
            <div className="bg-gradient-to-br from-cyan-400/20 to-blue-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-cyan-300/30">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-brain-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Desarrollo Cognitivo</h3>
              <p className="text-sm sm:text-base text-blue-100">
                La IA potencia el pensamiento crítico, la resolución de problemas complejos y estimula la creatividad desde temprana edad.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-400/20 to-pink-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-purple-300/30">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-rocket-2-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Preparación Futuro</h3>
              <p className="text-sm sm:text-base text-blue-100">
                El 85% de los empleos del 2030 aún no existen. La IA prepara a los estudiantes para profesiones emergentes.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-400/20 to-cyan-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-green-300/30">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-green-400 to-cyan-500 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-lightbulb-line text-white text-xl sm:text-2xl"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Aprendizaje Personalizado</h3>
              <p className="text-sm sm:text-base text-blue-100">
                Adapta el ritmo y estilo de aprendizaje a cada estudiante, maximizando su potencial individual.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparativa Visual */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-r from-blue-500 via-purple-600 to-cyan-500">
        <div className="container mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-white mb-12 sm:mb-16">
            El Impacto de la IA en el Aprendizaje
          </h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            {/* Sin IA */}
            <div className="bg-gradient-to-br from-red-500/20 to-orange-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-lg border border-red-300/30">
              <div className="text-center mb-6 sm:mb-8">
                <div className="w-16 h-16 sm:w-24 sm:h-24 bg-gradient-to-r from-red-400 to-orange-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-close-line text-white text-2xl sm:text-3xl"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Sin Formación en IA</h3>
              </div>
              
              <img 
                src="https://readdy.ai/api/search-image?query=Traditional%20classroom%20with%20children%20studying%20from%20textbooks%2C%20outdated%20learning%20methods%2C%20students%20looking%20confused%20and%20disengaged%2C%20old-fashioned%20educational%20environment%2C%20black%20and%20white%20vintage%20style&width=600&height=400&seq=without-ai-education&orientation=landscape" 
                alt="Educación tradicional"
                className="w-full h-32 sm:h-48 object-cover rounded-lg mb-4 sm:mb-6"
              />
              
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start text-red-200 text-sm sm:text-base">
                  <i className="ri-close-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Limitaciones en resolución de problemas complejos</span>
                </li>
                <li className="flex items-start text-red-200 text-sm sm:text-base">
                  <i className="ri-close-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Menor adaptabilidad a cambios tecnológicos</span>
                </li>
                <li className="flex items-start text-red-200 text-sm sm:text-base">
                  <i className="ri-close-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Desventaja competitiva en el mercado laboral</span>
                </li>
                <li className="flex items-start text-red-200 text-sm sm:text-base">
                  <i className="ri-close-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Dependencia de métodos tradicionales</span>
                </li>
              </ul>
            </div>

            {/* Con IA */}
            <div className="bg-gradient-to-br from-green-400/20 to-cyan-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-lg border-2 border-green-300/50">
              <div className="text-center mb-6 sm:mb-8">
                <div className="w-16 h-16 sm:w-24 sm:h-24 bg-gradient-to-r from-green-400 to-cyan-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-check-line text-white text-2xl sm:text-3xl"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">Con Formación en IA</h3>
              </div>
              
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20children%20using%20AI%20technology%20in%20bright%20classroom%2C%20happy%20students%20with%20tablets%20and%20holographic%20displays%2C%20diverse%20kids%20collaborating%20with%20robots%20and%20digital%20interfaces%2C%20innovative%20educational%20environment%20with%20vibrant%20colors&width=600&height=400&seq=with-ai-education&orientation=landscape" 
                alt="Educación con IA"
                className="w-full h-32 sm:h-48 object-cover rounded-lg mb-4 sm:mb-6"
              />
              
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start text-green-200 text-sm sm:text-base">
                  <i className="ri-check-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Pensamiento crítico y analítico avanzado</span>
                </li>
                <li className="flex items-start text-green-200 text-sm sm:text-base">
                  <i className="ri-check-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Alta adaptabilidad a nuevas tecnologías</span>
                </li>
                <li className="flex items-start text-green-200 text-sm sm:text-base">
                  <i className="ri-check-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Ventaja competitiva en empleos del futuro</span>
                </li>
                <li className="flex items-start text-green-200 text-sm sm:text-base">
                  <i className="ri-check-circle-line mr-2 sm:mr-3 flex-shrink-0 mt-0.5"></i>
                  <span>Creatividad potenciada por herramientas IA</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Estadísticas de Impacto */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-r from-cyan-500 via-blue-600 to-purple-700 text-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">
              El Impacto de la IA en Números
            </h2>
            <p className="text-base sm:text-lg md:text-xl opacity-90 px-4">
              Datos que demuestran la importancia crítica de la educación en IA
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            <div className="bg-gradient-to-br from-cyan-400/20 to-blue-500/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 shadow-lg border border-cyan-300/30 text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 sm:mb-4">75%</div>
              <p className="text-sm sm:text-base md:text-lg">de los empleos requerirán habilidades en IA para 2030</p>
            </div>
            <div className="bg-gradient-to-br from-green-400/20 to-cyan-500/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 shadow-lg border border-green-300/30 text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 sm:mb-4">40%</div>
              <p className="text-sm sm:text-base md:text-lg">mejora en rendimiento académico con IA personalizada</p>
            </div>
            <div className="bg-gradient-to-br from-purple-400/20 to-pink-500/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 shadow-lg border border-purple-300/30 text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 sm:mb-4">90%</div>
              <p className="text-sm sm:text-base md:text-lg">de estudiantes muestran mayor engagement con IA</p>
            </div>
            <div className="bg-gradient-to-br from-yellow-400/20 to-orange-500/20 backdrop-blur-sm rounded-2xl p-4 sm:p-6 shadow-lg border border-yellow-300/30 text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 sm:mb-4">$15.7T</div>
              <p className="text-sm sm:text-base md:text-lg">contribución global esperada de la IA en 2030</p>
            </div>
          </div>
        </div>
      </section>

      {/* Beneficios Académicos */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-cyan-500">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 sm:mb-6">
              Cómo la IA Complementa la Educación Académica
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-blue-100 max-w-3xl mx-auto px-4">
              La inteligencia artificial no reemplaza la educación tradicional, la potencia y la lleva al siguiente nivel
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-gradient-to-br from-cyan-400/20 to-blue-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-cyan-300/30">
              <img 
                src="https://readdy.ai/api/search-image?query=Mathematics%20and%20AI%20integration%2C%20children%20solving%20complex%20equations%20with%20AI%20assistance%2C%20mathematical%20formulas%20floating%20in%20holographic%20displays%2C%20innovative%20STEM%20education%20with%20digital%20tools&width=400&height=300&seq=math-ai-integration&orientation=landscape" 
                alt="Matemáticas con IA"
                className="w-full h-32 sm:h-48 object-cover rounded-lg mb-4 sm:mb-6"
              />
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Matemáticas Potenciadas</h3>
              <p className="text-sm sm:text-base text-blue-100">
                Visualización de conceptos complejos, resolución paso a paso y adaptación al ritmo individual de aprendizaje.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-400/20 to-cyan-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-green-300/30">
              <img 
                src="https://readdy.ai/api/search-image?query=Science%20laboratory%20with%20AI%20technology%2C%20children%20conducting%20experiments%20with%20robotic%20assistants%2C%20molecular%20structures%20in%20virtual%20reality%2C%20interactive%20scientific%20learning%20environment&width=400&height=300&seq=science-ai-lab&orientation=landscape" 
                alt="Ciencias con IA"
                className="w-full h-32 sm:h-48 object-cover rounded-lg mb-4 sm:mb-6"
              />
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Ciencias Interactivas</h3>
              <p className="text-sm sm:text-base text-blue-100">
                Simulaciones avanzadas, laboratorios virtuales y análisis de datos en tiempo real para experimentos seguros.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-400/20 to-pink-500/20 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-purple-300/30">
              <img 
                src="https://readdy.ai/api/search-image?query=Language%20learning%20with%20AI%20technology%2C%20children%20practicing%20different%20languages%20with%20AI%20tutors%2C%20interactive%20conversation%20with%20virtual%20teachers%2C%20multilingual%20educational%20environment&width=400&height=300&seq=language-ai-learning&orientation=landscape" 
                alt="Idiomas con IA"
                className="w-full h-32 sm:h-48 object-cover rounded-lg mb-4 sm:mb-6"
              />
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Idiomas Adaptativos</h3>
              <p className="text-sm sm:text-base text-blue-100">
                Conversación natural con IA, corrección inmediata de pronunciación y aprendizaje cultural contextualizado.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-r from-gray-900 via-blue-900 to-purple-900 text-white">
        <div className="container mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">
            Prepara a tus Estudiantes para el Futuro
          </h2>
          <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-10 opacity-90 max-w-3xl mx-auto px-4">
            No dejes que tus estudiantes se queden atrás. El futuro requiere habilidades en IA, y ese futuro es hoy.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center px-4">
            <Link 
              to="/modulos" 
              className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer text-center"
            >
              Explorar Curso Completo
            </Link>
            <Link 
              to="/precios" 
              className="border-2 border-cyan-400 text-cyan-300 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-cyan-400 hover:text-blue-900 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
            >
              Ver Opciones de Inversión
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
